import { IEmailAddOrEdit } from "../models/response/email/IEmailAddOrEdit";
import { IEmailUser } from "../models/response/email/IEmailUser";
import { apiClient } from "./apiClient";

export const emailApi = {
    getEditModel: (payload: number) => apiClient.get(`email/${payload}`),
    save: (payload: IEmailAddOrEdit) => apiClient.post(`email`, payload),
    getUsers: (payload: number) => apiClient.get(`email/${payload}/users`),
    saveUsers: (payload: IEmailUser[]) => apiClient.post(`email/users`, payload),
    send: (payload: number) => apiClient.put(`email/${payload}/send`),
}